import { render, staticRenderFns } from "./Layout3.vue?vue&type=template&id=4aaf5a10&"
import script from "./Layout3.vue?vue&type=script&lang=js&"
export * from "./Layout3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports